/**
 * @Description: 客户端应用程序的信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  ApplicationModel,
  ApplicationSearchModel,
  ApplicationPageSearchModel,
  ApplicationAddModel,
  ApplicationUpdateModel,
  IdsModel
} from '@/model/product/ApplicationModel'

const baseUrl = Route.product + '/application'

/**
 * 搜索分页数据
 */
export const pageSearchApplication = (param: ApplicationPageSearchModel) => {
  return https().request<RootObject<PageRespModel<ApplicationModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchApplication = (param: ApplicationSearchModel) => {
  return https().request<RootObject<ApplicationModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getApplication = (id: number) => {
  return https().request<RootObject<ApplicationModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addApplication = (param: ApplicationAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateApplication = (param: ApplicationUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeApplication = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveApplication = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
